var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.95 4H20.5C21.3284 4 22 4.67157 22 5.5V19.5C22 21.433 20.433 23 18.5 23H6.5C4.567 23 3 21.433 3 19.5V5.5C3 4.67157 3.67157 4 4.5 4H8.05001C8.28164 2.85888 9.29052 2 10.5 2H14.5C15.7095 2 16.7184 2.85888 16.95 4ZM8.05001 5H4.5C4.22386 5 4 5.22386 4 5.5V19.5C4 20.8807 5.11929 22 6.5 22H18.5C19.8807 22 21 20.8807 21 19.5V5.5C21 5.22386 20.7761 5 20.5 5H16.95C16.7184 6.14112 15.7095 7 14.5 7H10.5C9.29052 7 8.28164 6.14112 8.05001 5ZM10.5 3C9.67157 3 9 3.67157 9 4.5C9 5.32843 9.67157 6 10.5 6H14.5C15.3284 6 16 5.32843 16 4.5C16 3.67157 15.3284 3 14.5 3H10.5Z",
    fill: "#005383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1673 11.8327C17.2776 12.9431 17.2776 14.7432 16.1673 15.8536L14.2678 17.753C13.2915 18.7294 11.7085 18.7294 10.7322 17.753L8.83274 15.8536C7.72242 14.7432 7.72242 12.9431 8.83274 11.8327C9.83168 10.8338 11.389 10.7336 12.5 11.5321C13.611 10.7336 15.1683 10.8338 16.1673 11.8327ZM11.4393 17.0459C12.0251 17.6317 12.9749 17.6317 13.5607 17.0459L15.4602 15.1464C16.1799 14.4267 16.1799 13.2596 15.4602 12.5398C14.7404 11.8201 13.5733 11.8201 12.8536 12.5398L12.5 12.8934L12.1464 12.5398C11.4267 11.8201 10.2596 11.8201 9.53984 12.5398C8.82005 13.2596 8.82005 14.4267 9.53984 15.1464L11.4393 17.0459Z",
    fill: "#5CA9D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResults);
export default __webpack_public_path__ + "static/media/results.f170744abbae4b097b1978efa41fcfbf.svg";
export { ForwardRef as ReactComponent };